/* eslint-disable id-length */
import React from 'react';

export interface FlexProps {
  children?: React.ReactNode;
  className?: string;
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse' | 'initial' | 'inherit';
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'initial' | 'inherit';
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'initial' | 'inherit';
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: number;
  width?: string | number;
  maxWidth?: string;
  maxHeight?: string;
  style?: React.CSSProperties;
  id?: string;
  gap?: number;
  dataTestId?: string;
  role?: string;
}

// eslint-disable-next-line react/display-name
export const Flex = React.forwardRef<HTMLDivElement, FlexProps>((props, ref) => {
  const {
    children,
    className,
    justifyContent = 'flex-start',
    alignItems = 'flex-start',
    flexBasis = 'auto',
    flexGrow = 0,
    flexShrink = 1,
    flexDirection = 'row',
    flexWrap = 'nowrap',
    width = 'auto',
    maxWidth = 'none',
    maxHeight = 'none',
    style,
    id,
    gap,
    dataTestId,
    role,
  } = props;

  return (
    <div
      id={id}
      ref={ref}
      className={className}
      style={{
        ...style,
        display: 'flex',
        justifyContent,
        flexDirection,
        flexGrow,
        flexBasis,
        flexShrink,
        flexWrap,
        alignItems,
        width,
        maxWidth,
        maxHeight,
        gap,
      }}
      data-testid={dataTestId}
      role={role}
    >
      {children}
    </div>
  );
});
